import styled from '@emotion/styled';
import { Text } from '@radix-ui/themes';

interface UserBubbleProps {
  content: string;
}

const Bubble = styled.div`
  align-self: flex-end;
  max-width: 80%;
  background-color: #1a6b4a;
  color: white;
  border-radius: 16px 16px 4px 16px;
  padding: var(--space-2) var(--space-3);

  ::selection,
  *::selection {
    background-color: rgba(255, 255, 255, 0.35);
    color: white;
  }
`;

export function UserBubble({ content }: UserBubbleProps) {
  return (
    <Bubble>
      <Text size="2" weight="medium">
        {content}
      </Text>
    </Bubble>
  );
}
